// Single source of truth for config names.
export const Config = {
  test: 'test',
  REQUEST_MAGIC_LINK_FORM: 'REQUEST_MAGIC_LINK_FORM',
} as const

export type ConfigName = (typeof Config)[keyof typeof Config]
